const CONSTANTURL = {
  // production: {
  //   STUDIO:
  //     "https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
  //   LOGIN: "https://azuq6zfu0l.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
  //   FEEDBACK:
  //     "https://45nqltb6r4.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
  //   DASHBOARD:
  //     "https://whauq4bfc0.execute-api.ap-south-1.amazonaws.com/prod/api/v1",
  //   TRAINING:
  //     "https://4zgvlwchqg.execute-api.ap-south-1.amazonaws.com/prod/api/v1",
  //   TRAINING_EXTEND:
  //     "https://l57wedfp5m.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
  //   S3_BUCKET: "ure-ami-project-prod",
  // },
  production: {
    DASHBOARD:
      "https://whauq4bfc0.execute-api.ap-south-1.amazonaws.com/prod/api/v1",

    STUDENT:
      "https://4rrpzjwehk.execute-api.ap-south-1.amazonaws.com/prod/api/v1",

    FEEDBACK:
      "https://1p1gz2b79e.execute-api.ap-south-1.amazonaws.com/prod/api/v1",

    TRAINING:
      "https://4zgvlwchqg.execute-api.ap-south-1.amazonaws.com/prod/api/v1",

    LOGIN:
      "https://otj3vbncnj.execute-api.ap-south-1.amazonaws.com/prod/api/v1",

    TRAINING_EXTEND:
      "https://m64ovruyhd.execute-api.ap-south-1.amazonaws.com/prod/api/v1",

    STUDIO:
      "https://y3zvz24fjf.execute-api.ap-south-1.amazonaws.com/prod/api/v1",

    S3_BUCKET: "ure-ami-project-prod",
  },
  uat: {
    STUDIO:
      "https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    LOGIN: "https://azuq6zfu0l.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    FEEDBACK:
      "https://45nqltb6r4.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    DASHBOARD:
      "https://re9q02gew0.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    TRAINING:
      "https://e6ajh3xbob.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    // TRAINING_EXTEND:
    //   "https://l57wedfp5m.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    STUDENT:
      "https://p8qnqiuwg7.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    TRAINING_EXTEND:
      "https://l57wedfp5m.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    S3_BUCKET: "ure-ami-project-dev",
  },
  local: {
    LOGIN: "http://localhost:3001/api/v1",

    STUDIO: "http://localhost:3002/api/v1",

    FEEDBACK: "http://localhost:3003/api/v1",

    DASHBOARD: "http://localhost:3004/api/v1",

    TRAINING: "http://localhost:3005/api/v1",

    TRAINING_EXTEND: "http://localhost:3006/api/v1",

    STUDENT: "http://localhost:3007/api/v1",

    SUPPORT: "http://localhost:3009/api/v1",
    S3_BUCKET: "ure-ami-project-dev",
  },
  staging: {
    LOGIN:
      "https://g2yoc096ia.execute-api.ap-south-1.amazonaws.com/staging/api/v1",

    STUDIO:
      "https://xklrgu0b21.execute-api.ap-south-1.amazonaws.com/staging/api/v1",

    FEEDBACK:
      "https://cr26avmd9j.execute-api.ap-south-1.amazonaws.com/staging/api/v1",

    DASHBOARD:
      "https://598dchz864.execute-api.ap-south-1.amazonaws.com/staging/api/v1",

    TRAINING:
      "https://o5bew4cu8f.execute-api.ap-south-1.amazonaws.com/staging/api/v1",

    TRAINING_EXTEND:
      "https://vn127ol52a.execute-api.ap-south-1.amazonaws.com/staging/api/v1",

    STUDENT:
      "https://5szlbl4bcj.execute-api.ap-south-1.amazonaws.com/staging/api/v1",
    S3_BUCKET: "ure-ami-project-staging",
  },
};

export default CONSTANTURL;
